export default __webpack_public_path__ + "static/SR France - Process Flow Chart - Caramel Colors-26d06a1f452b6959bc15864a5bfcfa96.pdf";